var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[(_vm.getIsUserAdmin)?_c('HomeAdmin'):_vm._e(),(_vm.getIsUserTeacher)?_c('HomeTeacher'):_vm._e(),(_vm.getIsUserStudent)?_c('HomeStudent'):_vm._e(),(!_vm.getSignedIn)?_c('Signin'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }